<app-card [titleKey]="translationKey + 'cardTitle'">
  <div>
    <label class="sub-section-header">{{
      translationKey + "lenderInformation" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{ projectDetails().crowdfundingServiceProviderDetails }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "loanRatesRange" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{
        projectDetails()
          .minAndMaxInterestRatesForLoansAvailableToIndividualInvestorPortfolios
      }}
    </p>
    <br />
    <p>
      {{ projectDetails().minAndMaxLoanTermsForIndividualInvestorPortfolios }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "riskDistribution" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{
        projectDetails()
          .creditRiskCategoriesDistributionDefaultRatesAndWeightedAverageInterestRatesByRiskCategoryAndYear
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "internalMethodology" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{
        projectDetails()
          .keyElementsOfInternalMethodologyForCreditRiskAssessmentAndRiskCategoryDeterminationForIndividualCrowdfundingProjects
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "confidenceRate" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{
        projectDetails()
          .annualizedTargetRateAndConfidenceIntervalConsideringFeesAndDefaultRates
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "creditPortfolioSelection" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{
        projectDetails()
          .proceduresInternalMethodologiesAndCriteriaForSelectingCrowdfundingProjectsForIndividualInvestorPortfolios
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "capitalGuarantees" | translate
    }}</label>
  </div>
  <div class="text-box">
    <p>
      {{ projectDetails().coverageAndConditionsOfApplicableCapitalGuarantees }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "defaultStrategy" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .managementOfPortfolioLoansIncludingDefaultByProjectOwner
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "riskSharing" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{ projectDetails().riskSharingStrategies }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "feesAndCharges" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .feesPayableByProjectOwnerOrInvestorIncludingDeductionsFromInterestPayableByProjectOwner
      }}
    </p>
  </div>
  <hr />
</app-card>
